module.exports = __webpack_public_path__ + "static/img/honor17.38aaee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor17.png
// module id = dXQd
// module chunks = 0